import { copy } from 'cerebral/operators'
import redirectRegistration from '../actions/redirectRegistration'
import sendRegistration from '../actions/sendRegistration'
import setRegistrationStepError from '../actions/setRegistrationStepError'
import setRegistrationStepSuccess from '../actions/setRegistrationStepSuccess'
import stepSetUnvalidating from '../actions/stepSetUnvalidating'
import stepSetValidating from '../actions/stepSetValidating'
import validateRegistrationFields from '../actions/validateRegistrationFields'

export default [
  stepSetValidating,
  validateRegistrationFields,
  {
    true: [
      [
        sendRegistration,
        {
          success: [
            setRegistrationStepSuccess,
            copy('input:nextPage', 'output:currentPage'),
            redirectRegistration
          ],
          error: [stepSetUnvalidating, setRegistrationStepError]
        }
      ]
    ],
    false: []
  },
  stepSetUnvalidating
]



// WEBPACK FOOTER //
// ./src/modules/login/chains/validateRegistrationBeforeNext.js